export enum IServiceLineClientKey {
  clientName = 'clientName',
  legalInformation = 'legalInformation',
  address = 'address',
  contacts = 'contacts',
  serviceLines = 'serviceLines',
  serviceLineName = 'serviceLineName',
  reminders = 'reminders',
  debtCollection = 'debtCollection',
}

export type SlStatus =
  | 'scheduled'
  | 'active'
  | 'completed'
  | 'cancelled'
  | 'upcomming'
  | 'past'
  | 'indefinite'
  | 'activePause'
  | 'debtCollection';
export type SlScope = 'reminders' | 'dcTransfers' | 'both';
export type SlAction = 'active' | 'paused';
export type SlStage =
  | 'softReminder'
  | 'reminder'
  | 'dcWarning'
  | 'debtCollection'
  | 'remindersPause'
  | 'debtCollectionPause'
  | 'both';

export type IServiceLine = {
  serviceLineName: string;
  id: string;
  serviceLineId: string;
  scope: SlScope;
  startAt: string;
  endAt: string | null;
  status: SlStatus;
  createdBy: string;
  temporalWorkflowId: string | null;
  createdAt: string;
  updatedAt: string;
};

export type ICreateServiceLine = {
  serviceLineId: string;
  scope: SlScope;
  startAt: string;
  endAt: string | null;
  createdBy: string;
  reason: string;
};

export type IUpdateServiceLine = {
  startAt?: string;
  endAt?: string | null;
  scope?: SlScope;
  updatedBy?: string;
  reason: string;
};

export enum ServiceLineAction {
  active = 'active',
  paused = 'paused',
}

export type IActivePausePeriod = {
  startAt: string;
  endAt: string | null;
};

export type IBaseServiceLine = {
  id: string;
  serviceLineId: string;
  serviceLineName: string;
  status: SlStatus;
  activeRemindersPause: IActivePausePeriod | null;
  activeDcPause: IActivePausePeriod | null;
  pausePeriods: IActivePausePeriod[];
};

export enum ServiceLineStatus {
  Scheduled = 'scheduled',
  Active = 'active',
  Completed = 'completed',
  Cancelled = 'cancelled',
  Upcomming = 'upcomming',
  Past = 'past',
  Indefinite = 'indefinite',
  ActivePause = 'activePause',
  DetbCollection = 'debtCollection',
}

export enum ServiceLineScope {
  Reminders = 'reminders',
  DcTransfers = 'dcTransfers',
  Both = 'both',
}

export enum ServiceLineStage {
  SoftReminder = 'softReminder',
  Reminder = 'reminder',
  DcWarning = 'dcWarning',
  DebtCollection = 'debtCollection',
  RemindersPause = 'remindersPause',
  DebtCollectionPause = 'debtCollectionPause',
  Both = 'both',
}

export type IServiceLineStatistics = {
  name: string;
  dataTestId: string;
  action: SlAction;
  icon: string;
  color: string;
  endDate?: string;
  startDate?: string;
};

export enum ServiceLineStatusOptions {
  Active = 'active',
  Upcomming = 'upcomming',
  Past = 'past',
  Indefinite = 'indefinite',
}

export type IServiceLineStage = {
  id: string;
  stage: SlStage;
  scope: SlScope;
  status?: SlStatus;
  startDate: string;
  endDate: string;
  createdBy: string;
  icon: string;
  reason?: string;
};

export type ServiceLineEventType =
  | 'scheduled'
  | 'activated'
  | 'deactivated'
  | 'cancelled'
  | 'updated';

export type IServiceLineEvent = {
  id: string;
  pauseId: string;
  serviceLineId: string;
  eventType: ServiceLineEventType;
  scope: SlScope;
  startAt: string;
  endAt: string | null;
  operator: string;
  eventAt: string;
  createdAt: string;
  updatedAt: string;
};
